import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BackgroundTheme from '../../../../Common/P2P/Header/BackgroundTheme';
import RoundButton from '../../../../Common/RoundButton';
import WithdrawalPopSucess from '../../../../utils/assests/withdrawalSuccess.png';
import Card from '@mui/material/Card';
import { Typography } from '@material-ui/core';
import CardContent from '@mui/material/CardContent';

function WithdrawalSuccess() {
  let dispatch = useDispatch();
  const history = useHistory();

  const gotoDashboard = () => {
    history.push({ pathname: '/p2p/dashboard' });
  };
  return (
    <>
      <BackgroundTheme>
        <Card className='redBorder widhdrawCard' style={{ marginBottom: 0 }}>
          <CardContent>
            <div>
              <div className='text-center'>
                <img
                  className='successImgStyles'
                  src={WithdrawalPopSucess}
                  alt=''
                />
              </div>
              <Box className='popupText'>
                <Typography>
                  Successful <br />
                  withdrawal
                </Typography>
              </Box>
              <div className='text-center'>
                <RoundButton
                  title='Back to dashboard'
                  onClick={gotoDashboard}
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </BackgroundTheme>
    </>
  );
}
export default WithdrawalSuccess;
